import {
  PackageDashboardHeader,
  PackageSummarySection,
  PackageRevenueOverviewSection,
  PackageRankingsSection,
  PackageBreakdownsSection,
  PackageRevenueStreamsSection,
  getPackageSummaryCards,
  getPackageTrendData,
  getPackageCategoryBreakdown,
  getPackageUserTypeBreakdown,
} from "../../../components/reportDashboard/packages/packages";
import {
  usePackageBreakdowns,
  usePackageRankings,
  usePackageRevenueStreams,
  usePackageRevenueTrends,
  usePackageSummaryMetrics,
  useReportDateRange,
} from "../../../hooks/useReportDashboard";
import { getErrorMessage } from "../../../utils/error";

export function Tours() {
  const { dateRange, onDateRangeChange } = useReportDateRange();

  const {
    data: summaryData,
    isLoading: summaryLoading,
    isError: summaryError,
    error: summaryErrObj,
    refetch: summaryRefetch,
  } = usePackageSummaryMetrics(dateRange);

  const {
    data: trendsData,
    isLoading: trendsLoading,
    isError: trendsError,
    error: trendsErrObj,
    refetch: trendsRefetch,
  } = usePackageRevenueTrends(dateRange);

  const {
    data: streamsData,
    isLoading: streamsLoading,
    isError: streamsError,
    error: streamsErrObj,
    refetch: streamsRefetch,
  } = usePackageRevenueStreams(dateRange);

  const {
    data: breakdownsData,
    isLoading: breakdownsLoading,
    isError: breakdownsError,
    error: breakdownsErrObj,
    refetch: breakdownsRefetch,
  } = usePackageBreakdowns(dateRange);

  const {
    data: rankingsData,
    isLoading: rankingsLoading,
    isError: rankingsError,
    error: rankingsErrObj,
    refetch: rankingsRefetch,
  } = usePackageRankings(dateRange);

  const summaryState = {
    loading: summaryLoading,
    error: summaryError,
    message: getErrorMessage(summaryErrObj),
    onRetry: () => summaryRefetch(),
  };

  const trendsState = {
    loading: trendsLoading,
    error: trendsError,
    message: getErrorMessage(trendsErrObj),
    onRetry: () => trendsRefetch(),
  };

  const streamsState = {
    loading: streamsLoading,
    error: streamsError,
    message: getErrorMessage(streamsErrObj),
    onRetry: () => streamsRefetch(),
  };

  const breakdownsState = {
    loading: breakdownsLoading,
    error: breakdownsError,
    message: getErrorMessage(breakdownsErrObj),
    onRetry: () => breakdownsRefetch(),
  };

  const rankingsState = {
    loading: rankingsLoading,
    error: rankingsError,
    message: getErrorMessage(rankingsErrObj),
    onRetry: () => rankingsRefetch(),
  };

  const summaryCards = getPackageSummaryCards(
    summaryData?.data?.summaryMetrics,
  );
  const monthlyTrend = getPackageTrendData(trendsData?.data?.revenueTrends);
  const categoryBreakdown = getPackageCategoryBreakdown(breakdownsData);
  const revenueByUserType = getPackageUserTypeBreakdown(breakdownsData);
  const revenueBySupplier = breakdownsData?.data?.revenueBySupplier || [];
  const topDestinations = rankingsData?.data?.topDestinations || [];
  const topPartners = rankingsData?.data?.topPartners || [];
  const topPackages = rankingsData?.data?.topPackages || [];
  const revenueStreams = streamsData?.data?.revenueStreams || [];

  return (
    <div className="space-y-6">
      <PackageDashboardHeader onDateRangeChange={onDateRangeChange} />

      <PackageSummarySection state={summaryState} summaryCards={summaryCards} />

      <PackageRevenueOverviewSection
        trendsState={trendsState}
        breakdownsState={breakdownsState}
        monthlyTrend={monthlyTrend}
        categoryBreakdown={categoryBreakdown}
      />

      <PackageRankingsSection
        state={rankingsState}
        topDestinations={topDestinations}
        topPartners={topPartners}
        topPackages={topPackages}
      />

      <PackageBreakdownsSection
        state={breakdownsState}
        revenueByUserType={revenueByUserType}
        revenueBySupplier={revenueBySupplier}
      />

      <PackageRevenueStreamsSection
        state={streamsState}
        revenueStreams={revenueStreams}
      />
    </div>
  );
}
